import React, { useState, useEffect } from 'react';
import { ENUMS } from '../../../utils/constants';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { translate, formatData, isNullOrEmpty, enumText, closeCollapsible } from '../../../utils/util';
import { Input, BackButton, Title, Button } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import InfiniteScrollUl from '../../../components/UI/InfiniteScrollUl';

const TransmissionList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            mvm: "",
            invoice: "",
            partNumber: "",
            journey: ""
        });
    const [transmissions, setTransmissions] = useState([]);

    useEffect(() => {
        if (props.transmissions?.items?.length > 0) {
            if (transmissions.length > 0 && currentPage === 0) {
                setTransmissions([...props.transmissions.items]);
            } else {
                setTransmissions((prevState) => ([...prevState, ...props.transmissions.items]));
            }
        } else {
            setTransmissions([]);
        }
        // eslint-disable-next-line
    }, [props?.transmissions?.items]);

    const getTransmissionFilter = () => {
        if (validateInputsRequired("getReport")) {
            Object.assign(filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
            props.getTransmissions(filter, () => {
                closeCollapsible("filterTransmission");
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        if (currentPage > 0) {
            getTransmissionFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const validateRequired = () => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            return isNullOrEmpty(filter?.invoice)
        } else {
            return isNullOrEmpty(filter?.mvm)
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('line-picking:transmission.title')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterTransmission"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <form id="getReport" >
                                <div className="row">
                                    {getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD ?
                                        <div className="input-field no-padding col s5" >
                                            <Input
                                                id="invoice"
                                                name="invoice"
                                                label={translate('invoice', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.invoice || ''}
                                                onChange={onChange}
                                                required={isNullOrEmpty(filter?.journey)}
                                            />
                                        </div> :
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="mvm"
                                                name='mvm'
                                                label={translate('type-mvm', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.mvm || ''}
                                                onChange={onChange}
                                                required={isNullOrEmpty(filter?.journey)}
                                            />
                                        </div>
                                    }
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="journey"
                                            name='journey'
                                            label={translate('journey', 'physical-confirmation')}
                                            type="text"
                                            defaultValue={filter?.journey || ''}
                                            onChange={onChange}
                                            required={validateRequired()}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('partnumber', 'expedition:picking')}
                                            type="text"
                                            defaultValue={filter?.partNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </form>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button
                            full="true"
                            text="Buscar"
                            onClick={() => getTransmissionFilter()} />
                    </div>
                </div>
                <InfiniteScrollUl
                    page={props.transmissions?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.transmissions?.totalPages}
                    data={transmissions.map((item) => (
                        <div
                            className="row"
                            style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                        >
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {filter.mvm || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {item.receipt?.physicalConfirmation?.physicalConfirmationSheds?.journey || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {item.receipt?.dock || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {item.receipt?.partNumberCode || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {item.receipt?.invoice || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {translate('labels', 'general')}:{item?.boxQuantity || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {translate('parts', 'general')}:{item?.boxQuantityItems || ''}
                            </span>
                            <span className="title sixth-text-color" style={{ display: 'block' }} >
                                {translate('change-location:mdr')}:{item?.mdr || ''}
                            </span>
                            <div className="col s12 second-text-color"  >
                                {translate(enumText(ENUMS.eTransmissionType, item.type), 'physical-confirmation')} - {item?.receipt?.receiptStorages[0]?.masterCim || item?.receipt?.receiptStorages[0]?.cimPallet || item?.receipt?.receiptStorages[0]?.cim || ''}
                            </div>
                            <div className="col s12 second-text-color"  >
                                {translate(enumText(ENUMS.ePrintTypes, item.print), 'physical-confirmation')}
                            </div>
                            {
                                !item?.success && (
                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)} - {item.createdByDesc}
                                    </div>
                                )}
                            {
                                item?.success && (
                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:transmission.send')} - {formatData(item?.createdOn || '')} - {item.createdByDesc}
                                    </div>
                                )}
                            <div className="col s12 second-text-color"  >
                                {translate('attempts', 'physical-confirmation')} {item.attempts || ''}
                            </div>
                            {!isNullOrEmpty(item.message) &&
                                <div className="col s12 second-text-color"  >
                                    {translate('message', 'physical-confirmation')}: {item.message || ''}
                                </div>
                            }
                        </div>
                    ))}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.physicalConfirmationReducer.transmissions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getTransmissionsPaged(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TransmissionList)));
